import Radio from 'lib/components/radio/radio'
import Badge from 'lib/components/badge/badge'
import { ExternalLink } from 'lucide-react'

interface BillingModalPlatformProps {
  platform: string
  setPlatform: (value: string) => void
  period: string
}

export default function BillingModalPlatform({ platform, setPlatform, period }: BillingModalPlatformProps) {
  return (
    <div className="tw-mt-4 tw-flex tw-flex-col tw-gap-4">
      <div className="tw-flex tw-h-[4.5rem] tw-flex-row tw-items-center tw-gap-2 tw-rounded tw-border tw-border-solid tw-border-neutral-200 tw-p-4 has-[:checked]:tw-border-cornflower-300 has-[:checked]:tw-bg-neutral-50">
        <Radio
          id="base_platform"
          checked={platform === 'base'}
          name="platform"
          value="base"
          type="radio"
          onChange={() => setPlatform('base')}
          className="tw-cursor-pointer"
        />
        <label
          htmlFor="base_platform"
          className="tw-mb-0 tw-flex tw-w-full tw-cursor-pointer tw-justify-between tw-text-peppercorn-900"
        >
          <div className="tw-flex tw-items-center">
            <div className="tw-text-peppercorn-900">Base Platform</div>
            <Badge color="neutral" className="tw-ml-2">
              Current
            </Badge>
          </div>
          {platform === 'pro' && (
            <div className="tw-w-32 tw-text-right">
              <div className="tw-font-semibold tw-text-peppercorn-900">
                <span className="tw-mr-2 tw-text-peppercorn-400 tw-line-through">+$249.00</span>
                +$99.00
              </div>
              <div className="tw-font-normal">billed {period}</div>
            </div>
          )}
        </label>
      </div>
      <div className="tw-flex tw-flex-row tw-items-center tw-gap-2 tw-rounded tw-border tw-border-solid tw-border-neutral-200 tw-p-4 has-[:checked]:tw-border-cornflower-300 has-[:checked]:tw-bg-neutral-50">
        <Radio
          id="pro_platform"
          checked={platform === 'pro'}
          name="platform"
          value="pro"
          type="radio"
          onChange={() => setPlatform('pro')}
          className="tw-cursor-pointer"
        />
        <label
          htmlFor="pro_platform"
          className="tw-text-netutral-800 tw-mb-0 tw-flex tw-w-full tw-cursor-pointer tw-justify-between"
        >
          <div>
            <div className="tw-text-peppercorn-900">Pro Platform</div>
            <div className="tw-font-normal">
              Advanced functionality and integrations
              <a
                href="https://help.designpickle.com/en/"
                target="_blank"
                rel="noreferrer"
                className="tw-text-squash-600 tw-ml-2 tw-cursor-pointer tw-text-cornflower-500 hover:tw-underline"
              >
                Learn more
                <ExternalLink className="tw-ml-1 tw-h-4 tw-w-4 tw-align-sub" />
              </a>
            </div>
          </div>
          {platform === 'base' && (
            <div className="tw-w-24 tw-text-right">
              <div className="tw-font-semibold tw-text-peppercorn-900">+$150.00</div>
              <div className="tw-font-normal">billed {period}</div>
            </div>
          )}
        </label>
      </div>
    </div>
  )
}
